(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/init.js');

'use strict';

const {
  ApiProvider
} = window.RTKQ;
const {
  Start,
  SearchResults,
  Result
} = svs.grassroots.pages;
const {
  grassrootsQueryApi
} = svs.grassroots.store;
const {
  PlayerRouter,
  Route
} = svs.app.ReactRouter;
const {
  baseUrl
} = svs.core.data;
const {
  links
} = svs.grassroots;
const Context = React.createContext(null);
const InitComponent = () => {
  const isAuthenticated = svs.core.userSession && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);

  const {
    data,
    isLoading
  } = grassrootsQueryApi.useFetchReceiverSelectionQuery('', {
    skip: !isAuthenticated
  });
  const [selectedReceivers, setSelectedReceivers] = React.useState([]);
  const [countNumbers, setCountNumbers] = React.useState(true);
  React.useEffect(() => {
    if (data !== undefined) {
      setSelectedReceivers(data);
    }
  }, [data]);
  return React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(Context.Provider, {
    value: {
      selectedReceivers: {
        selectedReceivers,
        setSelectedReceivers,
        isLoading
      },
      countNumbers: {
        countNumbers,
        setCountNumbers
      }
    }
  }, React.createElement(Route, {
    exact: true,
    path: links.start,
    render: () => React.createElement(Start, null)
  }), React.createElement(Route, {
    exact: true,
    path: links.singlePattern,
    render: () => React.createElement(Start, null)
  }), React.createElement(Route, {
    path: links.search,
    render: () => React.createElement(SearchResults, null)
  }), React.createElement(Route, {
    path: links.result,
    render: () => React.createElement(Result, null)
  })), React.createElement(Route, {
    path: links.marketing,
    render: () => {
      window.location.href = svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing;
      return null;
    }
  }));
};
svs.grassroots.context.Context = Context;
ReactDOM.render(React.createElement(ApiProvider, {
  api: grassrootsQueryApi
}, React.createElement(InitComponent, null)), document.querySelector('.receivers-app'));

 })(window);